import { Checkbox, IconButton, TextField, Tooltip } from '@mui/material';
import { useRef, useCallback, useState, useEffect } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import TuneIcon from '@mui/icons-material/Tune';
import Scrollbars from 'rc-scrollbars';
import PropTypes from 'prop-types';
import { hoverStyle } from "styles/main";

export default function ClassicSearch({ setFilter, setChecked, checked, fields = undefined, setFields = undefined, customWidth = undefined }) {
    const textref = useRef(null);
    const settingsRef = useRef(null);          // ссылка на контейнер настроек
    const buttonRef = useRef(null);            // ссылка на кнопку открытия
    const [isOpen, setIsOpen] = useState(false);

    // Закрытие при клике вне области настроек и вне кнопки
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                isOpen &&
                settingsRef.current &&
                !settingsRef.current.contains(event.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const handleCheckboxChange = (e) => {
        if (checked) {
            setChecked(false);
        } else {
            if (textref.current?.value !== '') {
                setChecked(true);
                setFilter(textref.current?.value || '');
            }
        }
    };

    const handleTextChange = (e) => {
        if (textref.current?.value === '') {
            setChecked(false);
            setFilter('');
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleCheckboxChange(e);
        }
    };

    return (
        <div style={{ position: 'relative', width: customWidth || "290px" }}>
            <div style={{ display: 'flex', flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
                <TextField
                    inputRef={textref}
                    placeholder={"Поиск"}
                    onChange={handleTextChange}
                    onKeyDown={handleKeyDown}
                    sx={{
                        width: customWidth? "100%": "90%",
                        borderRadius: '10px',
                        backgroundColor: '#F5F9FA',//'rgba(255, 255, 255, 0.6)',
                        paddingLeft: "16px",
                        paddingRight: "16px",
                        '& .MuiInput-underline': {
                            '&:before': { borderBottom: 'none' },
                            '&:after': { borderBottom: 'none' },
                            '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                        },
                    }}
                    InputProps={{
                        endAdornment: (
                            <Checkbox
                                checked={checked}
                                sx={{ p: '12px', height: "20px", width: "20px" }}
                                icon={<SearchIcon />}
                                checkedIcon={<CloseIcon />}
                                onChange={handleCheckboxChange}
                            />
                        )
                    }}
                    variant="standard"
                />
                {fields && setFields && (
                    <Tooltip title="Настройки поиска">
                        <IconButton
                            ref={buttonRef}
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            <TuneIcon sx={{ transition: 'all 0.3s ease', '&:hover': hoverStyle }} />
                        </IconButton>
                    </Tooltip>
                )}
            </div>

            {fields && setFields && (
                <div
                    ref={settingsRef}
                    style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        width: '100%',
                        zIndex: 1000,
                        backgroundColor: 'white',
                        border: '1px solid #ccc',
                        borderRadius: '6px',
                        marginTop: '4px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        padding: '10px',
                        transition: 'all 0.3s ease',
                        opacity: isOpen ? 1 : 0,
                        transform: isOpen ? 'translateY(0)' : 'translateY(-12px)',
                        pointerEvents: isOpen ? 'auto' : 'none',
                        visibility: isOpen ? 'visible' : 'hidden',
                        height: "180px",
                        boxSizing: 'border-box',
                        overflow: 'hidden'
                    }}
                >
                    {isOpen && (
                        <Scrollbars style={{ height: "100%" }} autoHide>
                            {Object.keys(fields).map((k) => {
                                let el = fields[k];
                                return (
                                    <label key={el.id || el.name} style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '8px 5px',
                                        cursor: 'pointer',
                                        borderBottom: '1px solid #f0f0f0'
                                    }}>
                                        <input
                                            type="checkbox"
                                            style={{ marginRight: '10px', width: '16px', height: '16px', accentColor: '#208f84', flexShrink: 0 }}
                                            checked={el.active}
                                            onChange={(e) => {
                                                let tmp = JSON.parse(JSON.stringify(fields));
                                                tmp[k].active = e.target.checked;
                                                setFields(tmp);
                                            }}
                                        />
                                        <span style={{ fontSize: '14px' }}>{el.name}</span>
                                    </label>
                                );
                            })}
                        </Scrollbars>
                    )}
                </div>
            )}
        </div>
    );
}
